<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="title"
    width="35%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="100px"
      >
        <el-form-item
          v-if="createForm.courseId !== -1"
          label="课程名称"
          prop="courseId"
        >
          <el-select
            v-model="createForm.courseId"
            filterable
            clearable
            placeholder="请选择课程名称"
            class="w-50"
          >
            <el-option
              v-for="course in courseList"
              :key="course.id"
              :label="course.courseName"
              :value="course.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="createForm.offlineCourseId !== -1"
          label="线下课程名称"
          prop="offlineCourseId"
        >
          <el-select
            v-model="createForm.offlineCourseId"
            filterable
            clearable
            placeholder="请选择线下课程名称"
            class="w-50"
          >
            <el-option
              v-for="course in courseList"
              :key="course.id"
              :label="course.courseName"
              :value="course.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="身份证号"
          prop="userIdCard"
          class="w-80"
        >
          <el-input
            v-model="createForm.userIdCard"
            placeholder="请输入学员身份证号"
          />
        </el-form-item>
        <el-form-item
          label="姓名"
          prop="userName"
          class="w-80"
        >
          <el-input
            v-model="createForm.userName"
            placeholder="请输入学员姓名"
          />
        </el-form-item>
        <el-form-item
          label="发证日期"
          prop="certDate"
          class="w-80"
        >
          <el-date-picker
            v-model="createForm.certDate"
            type="date"
            clearable
            placeholder="请选择发证日期"
            format="yyyy.MM.dd"
            value-format="yyyy.MM.dd"
          />
        </el-form-item>
        <el-form-item
          label="性别"
          prop="userSex"
        >
          <el-radio-group v-model="createForm.userSex">
            <el-radio label="男">
              男
            </el-radio>
            <el-radio label="女">
              女
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="成绩"
          prop="scoreStr"
        >
          <el-radio-group v-model="createForm.scoreStr">
            <el-radio label="优秀">
              优秀
            </el-radio>
            <el-radio label="良好">
              良好
            </el-radio>
            <el-radio label="及格">
              及格
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="头像"
          prop="headUrl"
        >
          <upload
            :file-list.sync="createForm.headUrl"
            :auto-crop-height="178"
            :auto-crop-width="128"
          />
        </el-form-item>
      </el-form>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';
import upload from '@/components/common/upload/upload.vue';

export default {
  name: 'ProductDialog',
  components: { customeDialog, upload },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      title: '新增证书',
      courseList: [],
      fileList: [],
      createForm: {
        courseId: null,
        headUrl: '',
        scoreStr: '优秀',
        userIdCard: null,
        userSex: '女',
        userName: null,
        certDate: null,
        offlineCourseId: -1,
      },
      creatRules: {
        userName: [
          { required: true, message: '请输入学员姓名', trigger: 'change' },
        ],
        courseId: [
          { required: true, message: '请选择课程', trigger: 'blur' },
        ],
        offlineCourseId: [
          { required: true, message: '请选择线下课程', trigger: 'blur' },
        ],
        userIdCard: [
          {
            required: true, message: '请输入学员身份证号', trigger: 'blur',
          },
        ],
      },
      couponInfo: {},
    };
  },
  watch: {
    item(val) {
      if (val) {
        const {
          courseId,
          headUrl,
          scoreStr,
          userIdCard,
          userSex,
          userName,
          offlineCourseId,
          id,
        } = val;
        this.createForm = {
          courseId,
          headUrl,
          scoreStr,
          userIdCard,
          userSex,
          userName,
          offlineCourseId,
          id,
        };
        this.getCourseList();
        if (this.createForm.id) {
          this.title = '编辑证书';
        }
      }
    },
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.createForm.clearValidate();
        });
      }
    },
  },
  mounted() {
    this.getCourseList();
  },
  methods: {
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          const data = await axClient.cert.upsertCert(this.createForm);
          if (!data) return;
          if (this.createForm.id) {
            this.$message.success('修改证书成功');
          } else {
            this.$message.success('新增证书成功');
          }
          this.$emit('update:dialogVisible', false);
          this.$emit('confirm');
        }
      });
    },
    async getCourseList() {
      if (this.createForm.offlineCourseId === -1) {
        this.courseList = await axClient.cert.listCourseNameByCert();
      } else {
        const data = await axClient.cert.offlineCourse({
          pageSize: 0,
          pageNum: 0,
        });
        this.courseList = data.list;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.el-form {
  .w-80 {
    width: 80%;
  }
  .w-50 {
    width: 50%;
  }
}

</style>
